<div class="dialogWrapper">
    <header>
        <h2>{{ 'multiselect.selectedOptions' | translate }}</h2>
    </header>
    <div class="text-body">
        @for (option of data.selectedOptions; track option) {
            <div class="pill">
                <span>{{ $any(option).label | translate }}</span>
                @if (allowChanges && (!data.enforceOneValue || data.selectedOptions.length > 1)) {
                    <button class="transparent icon fal fa-xmark" (click)="deselectOption($any(option))"></button>
                }
            </div>
        }
    </div>
    <footer>
        @if (allowChanges) {
            <button class="button primary" title="{{ 'generalKeywords.confirm' | translate }}" (click)="closeModal(true)">
                {{ 'generalKeywords.confirm' | translate }}
            </button>
            <button class="button secondary" title="{{ 'generalKeywords.cancel' | translate }}" (click)="closeModal()">
                {{ 'generalKeywords.cancel' | translate }}
            </button>
        } @else {
            <button class="button secondary" title="{{ 'generalKeywords.close' | translate }}" (click)="closeModal()">
                {{ 'generalKeywords.close' | translate }}
            </button>
        }
    </footer>
</div>
